import React from 'react';

const Logo = () => {
  return (
    <div className="navbar-brand navbar-brand-autodark">
      <a href=".">
        <img
          src="/static/idai.jpg"
          alt="Logo"
          // style={{ height: 24 }} // atau sesuaikan ukuran sesuai kebutuhan
        />
      </a>
    </div>
  );
};

export default Logo;